"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useInitializeOneRouter_exports = {};
__export(useInitializeOneRouter_exports, {
  prepareForSSRRender: () => prepareForSSRRender,
  resetState: () => resetState,
  useInitializeOneRouter: () => useInitializeOneRouter
});
module.exports = __toCommonJS(useInitializeOneRouter_exports);
var import_core = require("@react-navigation/core");
var import_useLoader = require("../useLoader");
var routerStore = __toESM(require("./router"), 1);
var import_router = require("./router");
var import_linkingConfig = require("./linkingConfig");
var initVersion = 0;
var lastInitVersion = -1;
var ssrRouteTreeContext = null;
function useInitializeOneRouter(context, initialLocation, linking) {
  var navigationRef = (0, import_core.useNavigationContainerRef)();
  if (typeof window === "undefined") {
    if (ssrRouteTreeContext !== context) {
      (0, import_router.initialize)(context, navigationRef, initialLocation, linking);
      ssrRouteTreeContext = context;
      (0, import_linkingConfig.ensureBaseLinkingConfig)(routerStore.routeNode, linking);
    }
    var initialState = initialLocation ? (0, import_linkingConfig.getSSRInitialState)(routerStore.routeNode, initialLocation, linking) : routerStore.initialState;
    return {
      rootComponent: routerStore.rootComponent,
      navigationRef,
      initialState
    };
  }
  if (lastInitVersion !== initVersion || routerStore.navigationRef !== navigationRef) {
    var contexts = "__react_navigation__elements_contexts";
    globalThis[contexts] = /* @__PURE__ */ new Map();
    (0, import_router.initialize)(context, navigationRef, initialLocation, linking);
    lastInitVersion = initVersion;
  }
  return routerStore;
}
function prepareForSSRRender() {
  initVersion++;
}
function resetState() {
  prepareForSSRRender();
  (0, import_useLoader.resetLoaderState)();
}
globalThis["__vxrnresetState"] = resetState;
//# sourceMappingURL=useInitializeOneRouter.js.map
